<template>
  <div class="m-0 p-0" v-show="MessageBox.shown">
    <div class="bg-overlay"></div>

    <div class="message-box-container" :class="MessageBox.cancelButton ? 'message-box-container-wide' : ''" :style="MessageBox.style">
      <div class="box-content">
        <div class="title">KAHIN AI</div>
        <div class="message" v-html="MessageBox.message"></div>
      </div>
      <Button :label="MessageBox.buttonText" class="button" :class="MessageBox.cancelButton ? 'has-cancel-button' : ''"
              @click="buttonAction"/>
      <Button v-if="MessageBox.cancelButton" :label="MessageBox.cancelButton.buttonText"
              class="button bg-danger text-white" @click="cancelButtonAction"/>
      <a @click.prevent="MessageBox.buttonAction(); MessageBox.hide(true)" class="close-button-container"
         v-if="MessageBox.showCloseButton">
        <span class="material-symbols-outlined" style="font-size: 23pt">cancel</span>
      </a>
    </div>

  </div>
</template>

<script>
import {mapStores, mapState, mapActions, setMapStoreSuffix} from 'pinia';
import BackgroundStars from "@/components/BackgroundStars.vue";
import {MessageBox} from "@/store";
import Button from '@/components/basic/Button.vue';

setMapStoreSuffix("");

export default {
  components: {
    BackgroundStars,
    Button
  },

  computed: {
    ...mapStores(MessageBox)
  },

  methods: {
    buttonAction() {
      if (typeof this.MessageBox.buttonAction === 'function') {
        this.MessageBox.buttonAction();
      }
      this.MessageBox.hide();
    },

    cancelButtonAction() {
      if (typeof this.MessageBox.cancelButton.buttonAction === 'function') {
        this.MessageBox.cancelButton.buttonAction();
      }
      this.MessageBox.hide();
    }
  }
}
</script>

<style scoped>
.bg-overlay {
  width: 100%;
  height: 100%;
  display: block;
  position: fixed;
  z-index: 9999;
  background: #0B091898;
}

.message-box-container {
  z-index: 9999999;
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
  width: 300px;
  height: 200px;
  background: rgba(0, 0, 0, 0.70);
  border-radius: 16px;
  color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-left: 35px;
  padding-right: 35px;
  box-shadow: 0px 0px 26px #25163c;
}

.message-box-container-wide {
  height: 250px;
}

.box-content {
  position: absolute;
  top: 15px;
  text-align: center;
}

.title {
  color: var(--color-white);
  font-family: var(--font-aclonica), serif;
  font-size: 14pt;
}

.message {
  margin-top: 10px;
  padding-left: 10px;
  padding-right: 10px;
}

.button {
  padding-top: 5px;
  padding-bottom: 5px;
  position: absolute;
  bottom: 15px;
  width: 80%;
}

.has-cancel-button {
  bottom: 60px;
}

.close-button-container {
  display: block;
  width: 25px;
  height: 25px;
  position: absolute;
  top: -10px;
  right: -5px;
  color: #FFFFFF;
}
</style>
